import React, { useState, useEffect, act } from 'react';

//import NavigationBreadcrumbs from '../../components/ui/NavigationBreadcrumbs';
import UserDirectoryTree from './components/UserDirectoryTree';
import UserGrid from './components/UserGrid';
import UserProfilePanel from './components/UserProfilePanel';
import BulkOperationsPanel from './components/BulkOperationsPanel';
import UserImportModal from './components/UserImportModal';
import UserModal from './components/UserModal';
import Button from '../../components/ui/Button';
import { authService } from '../../services/supabaseService'; // Import du service
import RoleBasedHeader from '../../components/ui/RoleBasedHeader';
import { userService } from '../../services/supabaseService';
import { APP_NAME } from '../../constants';

const UserManagementAndRoleAdministration = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showImportModal, setShowImportModal] = useState(false);
  const [showBulkOperations, setShowBulkOperations] = useState(false);
  const [modalMode, setModalMode] = useState('create');
  const [showUserModal, setShowUserModal] = useState(false);
  
  // États pour l'utilisateur connecté
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Récupérer l'utilisateur connecté
  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        setLoading(true);
        const { user, error: userError } = await authService.getCurrentUser();
        
        if (userError) {
          console.error('Error fetching current user:', userError);
          setError('Failed to load user data');
          return;
        }

        if (user) {
          // Formater l'utilisateur selon le format attendu
          setCurrentUser({
            id: user.id,
            name: user.user_metadata?.full_name || user.email?.split('@')[0] || 'Utilisateur',
            email: user.email,
            role: user.user_metadata?.role || 'user',
            //avatar_url: user.user_metadata?.avatar_url
          });
        } else {
          setError('No user logged in');
        }
      } catch (err) {
        console.error('Error in fetchCurrentUser:', err);
        setError('Failed to load user data');
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentUser();
  }, []);

  const mockSystemStatus = {
    overall: 'operational',
    database: 'operational',
    api: 'operational',
    sync: 'operational',
    integrations: 'operational',
    lastUpdated: new Date().toISOString()
  };

  useEffect(() => {
    setShowBulkOperations(selectedItems.length > 0);
  }, [selectedItems]);

  const handleSaveUser = async (userData) => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('Saving user:', userData);
      console.log('Mode:', modalMode);
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Handle create vs edit logic
      if (modalMode === 'create') {
        console.log('Creating new user:', userData);
        // Add your create user logic here
      } else {
        console.log('Updating user:', userData);
        // Add your update user logic here
        setSelectedUser(userData); // Update the selected user in state
      }
      
      setShowUserModal(false);
      
    } catch (err) {
      console.error('Error saving user:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleTenantSelect = (tenant) => {
    setSelectedTenant(tenant);
    setSelectedDepartment(null);
    setSelectedRole(null);
    setSelectedUser(null);
  };

  const handleDepartmentSelect = (department) => {
    setSelectedDepartment(department);
    setSelectedRole(null);
    setSelectedUser(null);
  };

  const handleRoleSelect = (role) => {
    setSelectedRole(role);
    setSelectedUser(null);
  };

  const handleUserSelect = (user) => {
    setSelectedUser(user);
  };

  const handleSelectionChange = (items) => {
    setSelectedItems(items);
  };

  const handleCreateUser = () => {
    setModalMode('create');
    setSelectedUser(null); // Clear selected user for create mode
    setShowUserModal(true);
  };

  const handleEditUser = (user) => {
    setModalMode('edit');
    setSelectedUser(user);
    setShowUserModal(true);
  };

  const handleBulkAction = (actionId, items, data) => {
    console.log('Bulk action:', actionId, items, data);
    
    try {
      // Simulate different bulk actions
      switch (actionId) {
        case 'assign-role':
          console.log(`Assigning role "${data?.value}" to ${items.length} users`);
          break;
        case 'update-status':
          console.log(`Updating status to "${data?.value}" for ${items.length} users`);
          break;
        case 'enable-mfa':
          console.log(`Enabling MFA for ${items.length} users`);
          break;
        case 'send-notification':
          console.log(`Sending notification to ${items.length} users: ${data?.message}`);
          break;
        case 'export-data':
          console.log(`Exporting data for ${items.length} users`);
          break;
        default:
          console.log(`Unknown action: ${actionId}`);
      }
    } catch (err) {
      console.error('Error in bulk action:', err);
      setError(err.message);
    }
    
    // Clear selection after action
    setSelectedItems([]);
  };

  const handleClearSelection = () => {
    setSelectedItems([]);
  };

  const handleUserUpdate = async (updatedUser) => {
    try {

     const  usertoupdate={
        full_name: updatedUser.name,
        email: updatedUser.email,
        role: updatedUser.role,
        phone: updatedUser.phone,
        //avatar_url: updatedUser.avatar_url
        actif: updatedUser.active
      }
      console.log('User updated:', usertoupdate);
      await userService.updateUserProfile(updatedUser.id, usertoupdate);
      setSelectedUser(updatedUser);
    } catch (err) {
      console.error('Error updating user:', err);
      setError(err.message);
    }
  };

  const handleImport = (importData) => {
    try {
      console.log('Import data:', importData);
      setShowImportModal(false);
    } catch (err) {
      console.error('Error importing data:', err);
      setError(err.message);
    }
  };

  const handleQuickAction = (actionId, items) => {
    try {
      switch (actionId) {
        case 'create-new': 
          handleCreateUser();
          break;
        case 'import-data':
          setShowImportModal(true);
          break;
        case 'export-data':
          console.log('Exporting user data');
          break;
        case 'clear-selection':
          handleClearSelection();
          break;
        default:
          handleBulkAction(actionId, items, {});
      }
    } catch (err) {
      console.error('Error in quick action:', err);
      setError(err.message);
    }
  };

  // Mock tenants data
  const mockTenants = [
    {
      id: 'tenant-1',
      name: 'ArcOverify Inc.',
      description: 'Main corporate tenant',
      status: 'active',
      userCount: 45,
      created: '2024-01-15',
      domains: ['arcoverify.com']
    },
    {
      id: 'tenant-2',
      name: 'Development Lab',
      description: 'R&D and testing environment',
      status: 'active',
      userCount: 12,
      created: '2024-02-20',
      domains: ['dev.arcoverify.com']
    },
    {
      id: 'tenant-3',
      name: 'Client Services',
      description: 'Customer support and services division',
      status: 'active',
      userCount: 28,
      created: '2024-03-10',
      domains: ['support.arcoverify.com']
    },
    {
      id: 'tenant-4',
      name: 'Marketing Team',
      description: 'Marketing and communications',
      status: 'active',
      userCount: 8,
      created: '2024-01-30',
      domains: ['marketing.arcoverify.com']
    },
    {
      id: 'tenant-5',
      name: 'External Partners',
      description: 'Third-party collaborators and partners',
      status: 'inactive',
      userCount: 15,
      created: '2024-04-05',
      domains: ['partners.arcoverify.com']
    }
  ];

  // Options pour le dropdown
  const tenantOptions = mockTenants.map(tenant => ({
    value: tenant.id,
    label: tenant.name,
    description: tenant.description,
    status: tenant.status
  }));

  // Loading state principal
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Chargement des données utilisateur...</p>
        </div>
      </div>
    );
  }

  // Error state principal
  if (error && !currentUser) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-red-600 mb-2">Erreur de chargement</h2>
          <p className="text-muted-foreground mb-4">{error}</p>
          <Button onClick={() => window.location.reload()}>Réessayer</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
     <RoleBasedHeader
        userRole="admin"
        userName={`Admin ${APP_NAME}`}
         />

      
      <main className={`pt-16 transition-layout `}>
        <div className="p-6">
          
          {/* Page Header */}
          <div className="flex items-center justify-between mb-6">
            <div>
              <h1 className="text-2xl font-semibold text-foreground">Gestion des utilisateurs et administration des rôles</h1>
              <p className="text-muted-foreground mt-1">
                Gérer les utilisateurs, les rôles, les départements et les affectations au sein de l'organisation.
              </p>
            </div>
            
            <div className="flex items-center space-x-3">
              {/* <Button 
                variant="outline" 
                iconName="Upload" 
                iconPosition="left" 
                iconSize={16}
                onClick={() => setShowImportModal(true)}
                disabled={loading}
              >
                Importer des utilisateurs
              </Button> */}
              <Button 
                variant="default" 
                iconName="UserPlus" 
                iconPosition="left" 
                iconSize={16}
                onClick={handleCreateUser}
                disabled={loading}
              >
                Nouveau utilisateur
              </Button>
            </div>
          </div>

          {/* Error display pour les opérations */}
          {error && (
            <div className="mb-4 p-3 bg-red-100 border border-red-300 rounded-lg text-red-700">
              {error}
              <button 
                onClick={() => setError(null)} 
                className="ml-2 text-red-800 hover:text-red-900"
              >
                ×
              </button>
            </div>
          )}

          {/* Loading State pour les opérations */}
          {loading && (
            <div className="flex justify-center items-center py-8">
              <div className="text-muted-foreground">Traitement en cours...</div>
            </div>
          )}

          {/* Main Content Layout */}
          {!loading && (
            <div className="grid grid-cols-12 gap-6 h-[calc(100vh-200px)]">
              {/* Directory Tree - 25% */}
             

              {/* User Grid - 50% */}
              <div className="col-span-9">
                <UserGrid
                  selectedTenant={selectedTenant}
                  selectedUser={selectedUser}
                  onUserSelect={handleUserSelect}
                  onEditUser={handleEditUser}
                  selectedItems={selectedItems}
                  onSelectionChange={handleSelectionChange}
                  currentUserRole={currentUser?.role}
                  currentUserId={currentUser?.id}
                  searchTerm={searchTerm}
                  onSearchChange={setSearchTerm}
                  handleCreateUser={handleCreateUser}
                />
              </div>

              {/* User Profile Panel - 25% */}
              <div className="col-span-3">
                <UserProfilePanel
                  selectedUser={selectedUser}
                  onUserUpdate={handleUserUpdate}
                  onEditUser={handleEditUser}
                />
              </div>
            </div>
          )}

          {/* Quick Actions Panel */}
          
        </div>
      </main>

      {/* Bulk Operations Panel */}
      <BulkOperationsPanel
        selectedItems={selectedItems}
        onBulkAction={handleBulkAction}
        onClearSelection={handleClearSelection}
        isVisible={showBulkOperations}
      />

      {/* Import Modal */}
      <UserImportModal
        isOpen={showImportModal}
        onClose={() => setShowImportModal(false)}
        onImport={handleImport}
      />

      {/* User Modal */}
      <UserModal
        isOpen={showUserModal}
        onClose={() => setShowUserModal(false)}
        tenants={tenantOptions}
        user={selectedUser}
        currentUserRole={currentUser?.role}
        currentUserId={currentUser?.id}
        onSave={handleSaveUser}
        mode={modalMode}
        loading={loading}
      />
    </div>
  );
};

export default UserManagementAndRoleAdministration;